<template>
  <v-dialog
    v-model="dialog"
    width="500"
    height="350"
    @click:outside="close()"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="noButton"
        icon
        :title="title"
        :disabled="disabled"
        v-on="on"
      >
        <v-icon>
          {{ icon }}
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        {{ item.name }}
        <v-spacer />
        <v-btn
          icon
          :title="$t('dialog.close')"
          @click="close()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="12">
            <v-img
              v-if="item.mime.includes('zip') && picture != ''"
              max-width="100%"
              :lazy-src="picture"
              :src="picture"
            />
            <!-- IF MIME TYPE INCLUDES VIDEO -->
            <video
              v-if="item.mime.includes('video') && dialog"
              width="100%"
              controls
              muted
            >
              <!-- IF FILE EXTENSION IS MP4 -->
              <source
                v-if="item.ext.includes('mp4')"
                :src="translatePath(item.path)"
                type="video/mp4"
              />
              <!-- IF FILE EXTENSION IS WEBM -->
              <source
                v-if="item.ext.includes('webm')"
                :src="translatePath(item.path)"
                type="video/webm"
              />
            </video>
            <!-- IF MIME TYPE INCLUDES IMAGE -->
            <v-img
              v-if="item.mime.includes('image') && dialog"
              :lazy-src="translatePath(item.path)"
              :src="translatePath(item.path)"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// Connectors
import { ProjectConnector } from "../Database/ProjectConnector.js";

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "",
    },
    item: {
      type: Object,
      required: true,
    },
    noButton: {
      type: Boolean,
      default: true,
    },
    openDialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      projectConnector: new ProjectConnector(this.$store.state.user),
      dialog: false,
      model: "",
      picture: "",
    };
  },
  watch: {
    item: function () {
      this.getPicture();
    },
    openDialog: function (val) {
      this.dialog = val;
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.$emit("close");
    },
    translatePath(p) {
      if (p !== undefined) {
        const pathNorm = p.replace("public\\", "");
        return pathNorm;
      }
    },
    getPicture() {
      if (this.item.name !== undefined) {
        const _this = this;
        if (this.item.path.includes(".zip")) {
          this.projectConnector
            .getInfoWithPath(this.item.path.replace(".\\", "").replace("./", "").split("\\").join("/"))
            .then((pid) => {
              if (pid !== undefined) {
                _this.picture = "./mediacenter/tmb/" + pid + ".png?t=" + Date.now().toString();
              } else {
                _this.dialog = false;
              }
            })
            .catch((err) => {
              console.error(err);
            });
        }
      }
    },
  },
};
</script>

<style></style>
